import React, { useEffect, useState } from "react";
import "../../commoncss/Common.css";
import Cookies from "universal-cookie";
import Loader from "../../commoncomponents/Loader";
import { useToast } from "../../commoncomponents/ToastProvider";

const Agentdatadetail = (props) => {
  const [getFilter, setFilter] = useState({});
  const [getData, setData] = useState([{}]);
  const [getTrail, setTrail] = useState([{}]);
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  const cookie = new Cookies();

  const search_data = async () => {
    setLoading(true);
    try {
      props.setLoading("loading");
      const resp = await fetch(`${process.env.REACT_APP_URL}/agent/getdata`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({
          token: cookie.get("agent"),
          filter: { ...getFilter },
        }),
      });
      const dataset = await resp.json();
      console.log(dataset);
      if (resp.status === 200) {
        if (dataset.status === true) {
          setData(dataset.data);
          setTrail(dataset.data[0].data);
          showToast("Data search successfull", "success");
        } else {
          showToast("Failed to search data", "error");
        }
      } else {
        showToast(
          `Request error occured  while searching data ${resp.status}`,
          "error"
        );
      }
    } catch (error) {
      console.log("Failed  to search data", error);
      showToast("Network error occured, please try later", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {}, []);

  return (
    <div className="agent_wrapper">
      <div className="top_search_fields">
        <div className="fields_row">
          <div className="fields_item">
            <label>Enter Ticket ID</label>
            <input
              name="ticket"
              onChange={(e) => {
                setFilter({
                  ...getFilter,
                  [e.target.name]: e.target.value.trim(),
                });
              }}
              type="text"
              placeholder="Enter Ticket ID"
            />
          </div>
        </div>
        <div className="btn_container">
          <button
            onClick={(e) => {
              search_data();
            }}
          >
            {loading ? <Loader loading={loading} /> : "Search"}
          </button>
        </div>
      </div>
      <div className="table_container">
        <table>
          <tr>
            <th>Total Amount</th>
            <th>Last Amount</th>
            <th>Last Remark</th>
            <th>Name</th>
            <th>Phone</th>
            <th>Ticket</th>
            <th>Last Contacted By</th>
            <th>Updated Time</th>
            <th>Created Time</th>
            <th>Created By</th>
          </tr>
          {getData.map((e, index) => {
            if (Object.keys(e).length == 0) {
              return <tr></tr>;
            } else {
              var dataset = e.data;
              const updatetimeorg = new Date(
                dataset[dataset.length - 1].updated_time
              );
              const createtimeorg = new Date(e.created_time);
              const updatetime = `${
                updatetimeorg.getDate() > 9
                  ? updatetimeorg.getDate()
                  : "0" + updatetimeorg.getDate()
              }/${
                updatetimeorg.getMonth() > 8
                  ? updatetimeorg.getMonth() + 1
                  : "0" + (updatetimeorg.getMonth() + 1)
              }/${updatetimeorg.getFullYear()} ${
                updatetimeorg.getHours() > 9
                  ? updatetimeorg.getHours()
                  : "0" + updatetimeorg.getHours()
              }:${
                updatetimeorg.getMinutes() > 9
                  ? updatetimeorg.getMinutes()
                  : "0" + updatetimeorg.getMinutes()
              }:${
                updatetimeorg.getSeconds() > 9
                  ? updatetimeorg.getSeconds()
                  : "0" + updatetimeorg.getSeconds()
              }`;
              const createtime = `${
                createtimeorg.getDate() > 9
                  ? createtimeorg.getDate()
                  : "0" + createtimeorg.getDate()
              }/${
                createtimeorg.getMonth() > 8
                  ? createtimeorg.getMonth() + 1
                  : "0" + (createtimeorg.getMonth() + 1)
              }/${createtimeorg.getFullYear()} ${
                createtimeorg.getHours() > 9
                  ? createtimeorg.getHours()
                  : "0" + createtimeorg.getHours()
              }:${
                createtimeorg.getMinutes() > 9
                  ? createtimeorg.getMinutes()
                  : "0" + createtimeorg.getMinutes()
              }:${
                createtimeorg.getSeconds() > 9
                  ? createtimeorg.getSeconds()
                  : "0" + createtimeorg.getSeconds()
              }`;
              return (
                <tr>
                  <td>₹{(e.amount / 100).toLocaleString("en-IN")}</td>
                  <td>
                    ₹
                    {(dataset[dataset.length - 1].amount / 100).toLocaleString(
                      "en-IN"
                    ) == "NaN"
                      ? "0"
                      : (
                          dataset[dataset.length - 1].amount / 100
                        ).toLocaleString("en-IN")}
                  </td>
                  <td>{dataset[dataset.length - 1].remark}</td>
                  <td>{e.name}</td>
                  <td>{e.phone}</td>
                  <td>{e.ticket}</td>
                  <td>
                    Agent
                    {dataset[dataset.length - 1].entry_name}
                  </td>
                  <td>{updatetime}</td>
                  <td>{createtime}</td>
                  <td>{dataset[0].entry_name}</td>
                </tr>
              );
            }
          })}
        </table>
      </div>
      <div className="table_container">
        <table>
          <tr>
            <th>Amount</th>
            <th>Remark</th>
            <th>Contacted By</th>
            <th>Updated Time</th>
          </tr>
          {getTrail.map((e, index) => {
            if (Object.keys(e).length == 0) {
              return <tr></tr>;
            } else {
              const updatetimeorg = new Date(e.updated_time);
              const updatetime = `${
                updatetimeorg.getDate() > 9
                  ? updatetimeorg.getDate()
                  : "0" + updatetimeorg.getDate()
              }/${
                updatetimeorg.getMonth() > 8
                  ? updatetimeorg.getMonth() + 1
                  : "0" + (updatetimeorg.getMonth() + 1)
              }/${updatetimeorg.getFullYear()} ${
                updatetimeorg.getHours() > 9
                  ? updatetimeorg.getHours()
                  : "0" + updatetimeorg.getHours()
              }:${
                updatetimeorg.getMinutes() > 9
                  ? updatetimeorg.getMinutes()
                  : "0" + updatetimeorg.getMinutes()
              }:${
                updatetimeorg.getSeconds() > 9
                  ? updatetimeorg.getSeconds()
                  : "0" + updatetimeorg.getSeconds()
              }`;
              return (
                <tr>
                  <td>₹{(e.amount / 100).toLocaleString("en-IN")}</td>
                  <td>{e.remark}</td>
                  <td>{e.entry_name}</td>
                  <td>{updatetime}</td>
                </tr>
              );
            }
          })}
        </table>
      </div>

      <br />
    </div>
  );
};

export default Agentdatadetail;
